export default "__VITE_ASSET__BJi5zxV___"